import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import icons from '../assets/icons';
import './RecordFooter.css';

class RecordFooterComponent extends Component {
  static get propTypes() {
    return {
      editing: PropTypes.bool,
      state: PropTypes.string,
      onStartEditing: PropTypes.func.isRequired,
      onCancelEditing: PropTypes.func.isRequired,
      onCopy: PropTypes.func.isRequired,
      availableStates: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string
      })),
      onChangeState: PropTypes.func
    };
  }

  render() {
    const { editing } = this.props;
    return editing
      ? this.renderFormButtons()
      : this.renderFooter();
  }

  renderFormButtons() {
    const { onCancelEditing } = this.props;

    // The submit button submits the form that this
    // component is contained in
    return (<div className="RecordFooter">
      <div className="RecordFooter-actions">
        <span className="RecordFooter-label"><img alt="Edit" src={icons.grey.edit} /><span>Edit Mode</span></span>

        <input type="button" className="btn cancel-edit" onClick={onCancelEditing} value="Cancel" />
        <input type="submit" className="btn btn-submit save-record" value="Save" />
      </div>
    </div>);
  }

  onChangeState(s) {
    const { onChangeState } = this.props;
    if (s.mustConfirm) {
      if (window.confirm(`Are you sure you want to ${s.display}`)) {
        onChangeState(s);
      }
    } else {
      onChangeState(s);
    }
  }

  renderFooter() {
    const { state, onStartEditing, onCopy, availableStates } = this.props;
    return (<div className="RecordFooter">
      <div className="RecordFooter-actions">
        <button className="btn edit-record" onClick={onStartEditing}><img className="edit-record-icon" alt="Edit" src={icons.grey.edit} /><span>Edit</span></button>
        <button className="btn copy-record" onClick={onCopy}><img alt="Copy" src={icons.grey.duplicate} /><span>Copy</span></button>
      </div>
      <div className="RecordFooter-buttons">
        <span className="RecordFooter-state">{state}</span>
        {availableStates.map(s =>
          (<button
            key={s.key}
            className={classnames('btn', `record-action-${s.key}`, { 'btn-form': !s.default, 'btn-submit': s.default })}
            onClick={() => this.onChangeState(s)}
            disabled={s.disabled}
          >
            {s.display || s.name}
          </button>)
        )}
      </div>
    </div>);
  }
}

export default RecordFooterComponent;



// WEBPACK FOOTER //
// ./src/recordDetail/RecordFooter.js